import axios from 'axios';
import { getApiHeader } from './../services/getApiHeaders';

export function shipperInfor() {
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/user/currentshipper',
        headers: getApiHeader(),
        withCredentials: true,
    }
    return axios(options)
}

export const listShipper = (payload) => {
    return axios({
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/user/getshipers',
        headers: getApiHeader(),
        withCredentials: true,
        params: payload
    })
}

export const updateShipper = (payload) => {
    return axios({
        method: 'PUT',
        url: process.env.REACT_APP_URL + '/api/user/updatecurrentshipper',
        headers: getApiHeader(),
        withCredentials: true,
        data: payload
    })
}


// WEBPACK FOOTER //
// ./src/utils/shipperInfor.js